import {Coordinate2D} from "MeasurementsCalculations"
export class Mathematics {
    static polarToCartesian(center: Coordinate2D, radius: number, angleInDegrees: number) {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
        return new Coordinate2D(center.x + (radius * Math.cos(angleInRadians)), center.y + (radius * Math.sin(angleInRadians)));
    };

    static describeArc(center: Coordinate2D, radius: number, startAngle: number, endAngle: number) {
        var start = this.polarToCartesian(center, radius, endAngle);
        var end = this.polarToCartesian(center, radius, startAngle);
        var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
        var d = [
            "M", start.x, start.y,
            "A", radius, radius, 0, arcSweep, 0, end.x, end.y
        ].join(" ");
        return d;
    }
}
